export const unvisitedSiteFilteroptions = [
  {
    name: "FT",
    value: [["jbccTechnicianId"]],
    label: [["jbccTechnicianName"]],
  },
  {
    name: "Supervisor",
    value: [["jbccSupervisorId"]],
    label: [["jbccSupervisorName"]],
  },
  {
    name: "Duration",
    optionsList: [
      {
        value: 1,
        label: "low (<20 Days)",
      },
      {
        value: 2,
        label: "Medium (20-30 Days)",
      },
      {
        value: -1,
        label: "Urgent (>30 days)",
        color: "text-red-600",
      },
    ],
    valueAddress: [["priority"]],
    isStatic: true,
    unsort: true,
  },
];

export const UNVISITED_SITE_SEARCH = {
  id: ["id"],
  site: ["name"],
};

export const DEACTIVATED_SITES_SEARCH = {
  id: ["id"],
  site: ["name"],
  machine: ["machineID"],
};

export const MATERIAL_TRANSPORT_FILTERS_OPTIONS = [
  {
    name: "Field Technician",
    value: [["fieldTechnician", "id"]],
    label: [["fieldTechnician", "fullName"]],
  },
    {
    name: "Supervisor",
    value: [["supervisor", "id"]],
    label: [["supervisor", "fullName"]],
  },
  {
    name: "Material",
    value: [["material", "id"]],
    label: [["material", "name"]],
  },
  {
    name: "Status",
    optionsList: [
      {
        value: 1,
        label: "Completed",
        color: "text-green",
      },
      {
        value: 0,
        label: "Pending",
        color: "text-yellow-500",
      },
    ],
    valueAddress: [["status"]],
    isStatic: true,
    unsort: true,
  },
];
